import languageService, { languagesAtom } from "./languageService";
import { useAtom } from "jotai";

export const useI18n = ()=>{
    const [currentLanguage] = useAtom(languagesAtom);
    
    return { currentLanguage, languageService };
}